import api from "./api";

export const reviewService = {
  getAll: async () => (await api.get("/reviews")).data,
  getById: async (id: string) => (await api.get(`/reviews/${id}`)).data,
  approve: async (id: string) => (await api.put(`/reviews/${id}/approve`)).data,
  delete: async (id: string) => (await api.delete(`/reviews/${id}`)).data,
  createPublic: async (data: any) => (await api.post("/reviews", data)).data, // public endpoint
};

export default reviewService
